import React from "react";
import CustomBarChart from "../../common/custom-bar-chart/custom-bar-chart.js";
import CustomPieChart from "../../common/custom-pie-chart/custom-pie-chart.js";
import CustomLineChart from "../../common/custom-line-chart/custom-line-chart.js";

const LoadChartBasedOnType = ({ chartInfo }) => {
  const barChartDataMaper = () => {
    const result = [];
    const colors = ["#033666", "#00D1FF", "#0068A7", "#0092CA", "#00A7DC"];
    if (chartInfo.yAxis)
      chartInfo.yAxis.forEach((value, index) => {
        const label = chartInfo.xAxis[index];
        result.push({ value, label, color: colors[index] });
      });

    return result;
  };

  switch (chartInfo?.ChartType?.split(" ").join("").toLowerCase()) {
    case "piechart":
      return <CustomPieChart height={450} chartData={barChartDataMaper()} />;
    case "barchart":
    case "bar chart":
      return (
        <CustomBarChart
          height={450}
          chartData={{
            yAxisData: chartInfo.yAxis,
            xAxisData: chartInfo.xAxis,
          }}
        />
      );
    case "linechart":
      return (
        <CustomLineChart
          height={450}
          chartData={{
            yAxisData: chartInfo.yAxis,
            xAxisData: chartInfo.xAxis,
          }}
        />
      );
    default:
      return <></>;
  }
};

export default LoadChartBasedOnType;
